/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatchProductRequest } from './PatchProductRequest';
import {
    PatchProductRequestFromJSON,
    PatchProductRequestFromJSONTyped,
    PatchProductRequestToJSON,
    PatchProductRequestToJSONTyped,
} from './PatchProductRequest';

/**
 * 
 * @export
 * @interface PatchProductsBulkRequest
 */
export interface PatchProductsBulkRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchProductsBulkRequest
     */
    ids: Array<string>;
    /**
     * 
     * @type {PatchProductRequest}
     * @memberof PatchProductsBulkRequest
     */
    update: PatchProductRequest;
}

/**
 * Check if a given object implements the PatchProductsBulkRequest interface.
 */
export function instanceOfPatchProductsBulkRequest(value: object): value is PatchProductsBulkRequest {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    if (!('update' in value) || value['update'] === undefined) return false;
    return true;
}

export function PatchProductsBulkRequestFromJSON(json: any): PatchProductsBulkRequest {
    return PatchProductsBulkRequestFromJSONTyped(json, false);
}

export function PatchProductsBulkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchProductsBulkRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'],
        'update': PatchProductRequestFromJSON(json['update']),
    };
}

export function PatchProductsBulkRequestToJSON(json: any): PatchProductsBulkRequest {
    return PatchProductsBulkRequestToJSONTyped(json, false);
}

export function PatchProductsBulkRequestToJSONTyped(value?: PatchProductsBulkRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'],
        'update': PatchProductRequestToJSON(value['update']),
    };
}

